import { z } from 'zod';

// Finley design system color schemes
export const COLOR_SCHEMES = [
  'v2-aurora',
  'gray',
  'red',
  'orange',
  'blue',
  'green',
] as const;
export const ColorSchemeStruct = z.enum(COLOR_SCHEMES).default('v2-aurora');
export type ColorScheme = z.infer<typeof ColorSchemeStruct>;

// Alert statuses
export const ALERT_STATUS = [
  'error',
  'info',
  'loading',
  'success',
  'warning',
] as const;
export const AlertStatusStruct = z.enum(ALERT_STATUS).default('info');
export type AlertStatus = z.infer<typeof AlertStatusStruct>;
export const ALERT_STATUS_TO_COLOR_SCHEME: Record<AlertStatus, ColorScheme> = {
  error: 'red',
  info: 'blue',
  loading: 'blue',
  success: 'green',
  warning: 'orange',
};

// Finley design system sizes
export const SIZES = ['sm', 'md', 'lg'] as const;
export const SizesStruct = z.enum(SIZES).default('md');
export type Sizes = z.infer<typeof SizesStruct>;

// Finley font sizes
export const FONT_SIZES = [
  'xs',
  'sm',
  'base',
  'lg',
  'xl',
  '2xl',
  '3xl',
  '4xl',
  '5xl',
] as const;
export const FontSizesStruct = z.enum(FONT_SIZES).default('base');
export type FontSizes = z.infer<typeof FontSizesStruct>;

// Finley font weights
export const FONT_WEIGHTS = ['normal', 'medium', 'semibold', 'bold'] as const;
export const FontWeightsStruct = z.enum(FONT_WEIGHTS).default('normal');
export type FontWeights = z.infer<typeof FontWeightsStruct>;
